import vxProductTile from '../../common/vx-product-tile/vx-product-tile.vue';
import globals from '../../common/globals';
import CheckoutService from '../../common/services/checkout-service';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import {
  checkoutEventBus,
} from '../../../modules/event-bus';

export default {
  name: 'vx-gift-options',
  components: {
    vxProductTile,
    vxSpinner,
  },
  props: {
    // Array of Giftable products
    giftableProducts: Array,
    // Text coming from property file
    i18n: Object,
    // Index of Gift Options Section
    sectionIndex: Number,
  },
  data() {
    return {
      isEditable: true,
      globals,
      giftWrapDetails: [],
      dataLoaded: false,
      checkoutService: new CheckoutService(),
    };
  },
  computed: {},
  mounted() {
    this.giftWrapData();
    this.showSavedData();
  },
  methods: {
    /**
     * This function is triggered when user clicks on change button
     */
    editMethod(event) {
      this.isEditable = true;
      checkoutEventBus.$emit('section-edit', 'giftOptions');
    },
    /**
     * This function creates an object that stores the user input (like gift wrap selected and gift message)
     * and other gift related data like product name, address and price that needs to shown to the user
     */
    giftWrapData() {
      this.giftWrapDetails = [];
      this.giftableProducts.map((item) => {
        this.giftWrapDetails.push({
          entryNumber: item.entryNumber,
          giftWrapSelected: item.giftWrapped,
          giftWrapMessage: item.giftMessage || '',
          giftWrapCost: this.getKey(item.additionalAttributes.entry, 'giftableProductPrice').value,
        });
      });
      this.dataLoaded = true;
    },
    /**
     * This function shows already saved data if present in the cart call
     * (if user refreshes the page after saving gift options section)
     */
    showSavedData() {
      this.giftWrapDetails.map((item) => {
        const self = this;
        if (item.giftWrapSelected) {
          self.isEditable = false;
          checkoutEventBus.$emit('section-complete', 'giftOptions');
          checkoutEventBus.$emit('gift-saved', this.giftWrapDetails);
        } else {
          self.isEditable = true;
          checkoutEventBus.$emit('section-edit', 'giftOptions');
        }
      });
    },
    /**
     * This function Returns the matched element, else undefined.
     * @param  {Object} entry collection to inspect
     * @param  {String} keyCode key to be searched
     */
    getKey(entry, keyCode) {
      return _.find(entry, {
        key: keyCode,
      });
    },
    /**
     * This function creates request body for saving Gift Options Section
     */
    createRequestBody() {
      const requestBody = {};
      requestBody.giftWrap = [];
      this.giftableProducts.map((item, index) => {
        requestBody.giftWrap.push({
          entryNumber: item.entryNumber,
          giftMessage: this.giftWrapDetails[index].giftWrapMessage || '',
          giftWrapped: this.giftWrapDetails[index].giftWrapSelected || false,
        });
      });
      return requestBody;
    },
    /**
     * This function triggers the call to save Gift Options Section
     */
    saveGiftWrap(event) {
      this.$refs.spinner.showSpinner();
      const requestConfig = {};
      requestConfig.data = this.createRequestBody();
      this.checkoutService.saveGift(requestConfig, this.handleSaveGiftResponse, this.handleSaveGiftError);
    },
    /**
     * This function handles the response of save Gift options call and emits gift data to display on overview section
     */
    handleSaveGiftResponse() {
      this.$refs.spinner.hideSpinner();
      this.isEditable = false;
      checkoutEventBus.$emit('update-cart');
      checkoutEventBus.$emit('section-complete', 'giftOptions');
      checkoutEventBus.$emit('gift-saved', this.giftWrapDetails);
    },
    /**
     * This function handles the error of save Gift options call
     */
    handleSaveGiftError() {
      this.isEditable = true;
      this.$refs.spinner.hideSpinner();
    },
    /**
     * This function is triggered from HTML, returns the address in particular format
     * @param  {Object} item address object
     */
    getAddress(item) {
      let address = '';
      if (item.line2) {
        address = `${item.line1}, ${item.line2}, ${item.town}, ${item.postalCode}`;
      } else {
        address = `${item.line1}, ${item.town}, ${item.postalCode}`;
      }
      return address;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/checkout/vx-gift-options/vx-gift-options.js